export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'How will I receive the materials?',
    answer:
      'Immediately after your purchase you’ll receive digital access to the complete Renal Decision Desk™ system and all included bonuses. You can begin reviewing the resources within minutes.',
  },
  {
    question: 'Is this a physical product?',
    answer:
      'No. Renal Decision Desk™ is a digital product designed for use on desktop, tablet, phone, and for printing.',
  },
  {
    question: 'Is this a subscription?',
    answer:
      'No. It’s a one-time payment with lifetime access to the version purchased.',
  },
  {
    question: 'Is the information based on clinical guidelines?',
    answer:
      'The product is designed as an educational clinical decision-navigation resource informed by relevant evidence and guidelines. Because clinical recommendations can change, healthcare professionals should verify current recommendations, prescribing information, and applicable local guidance before applying them to individual patients.',
  },
  {
    question: 'Is this only for nephrologists?',
    answer:
      'No. The system is designed for physicians who encounter patients with renal abnormalities or chronic kidney disease in their clinical practice.',
  },
  {
    question: 'Do I need advanced nephrology training?',
    answer:
      'No advanced nephrology training is assumed for navigating the structure of the product. However, the product is intended for healthcare professionals and does not replace appropriate clinical training, judgment, current guidelines, or specialist consultation.',
  },
  {
    question: 'Does this replace clinical judgment or a nephrologist?',
    answer:
      'No. Renal Decision Desk™ is an educational and organizational resource. It does not replace individual clinical judgment, the physician-patient relationship, current clinical guidelines, prescribing information, or appropriate specialist consultation.',
  },
]
